import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faTiktok, faYoutube, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "../styles/Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Brand Info */}
        <div className="footer-col brand-info">
          <h2 className="footer-logo">Star.Ryhwa</h2>
          <p className="brand-description">
            Handcrafted K-Pop collages, custom sanitizer keychains, prints &amp; stickers, made in Hawaii.
          </p>
        </div>

        {/* Column 2: Navigation Links */}
        <div className="footer-col footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Shop</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/information">Information</Link></li>
            <li><Link to="/cart">Cart</Link></li>
          </ul>
        </div>

        {/* Column 3: Legal & Policies */}
        <div className="footer-col footer-links">
          <h3>Legal &amp; Policies</h3>
          <ul>
            <li><Link to="/shipping-policy">Shipping &amp; Returns</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/disclaimers">Disclaimers</Link></li>
            <li><Link to="/accessibility">Accessibility</Link></li>
          </ul>
        </div>

        {/* Column 3: Social & Contact Links */}
        <div className="footer-col footer-socials">
          <h3>Connect With Us</h3>
          <p>Stay updated & DM us for custom orders!</p>
          <div className="social-icons">
            <a href="https://www.instagram.com/star.ryhwa?igsh=NTc4MTIwNjQ2YQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} size="lg" />
            </a>
            <a href="https://www.tiktok.com/@star.ryhwa?_r=1&_t=ZT-97YHF75VUir" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FontAwesomeIcon icon={faTiktok} size="lg" />
            </a>
            <a href="https://www.youtube.com/@Starryhwaaa" target="_blank" rel="noopener noreferrer" aria-label="YouTube" title="YouTube @Starryhwaaa">
              <FontAwesomeIcon icon={faYoutube} size="lg" />
            </a>
            <a href="mailto:officialstar.ryhwa@gmail.com" aria-label="Email Us" title="Email officialstar.ryhwa@gmail.com">
              <FontAwesomeIcon icon={faEnvelope} size="lg" />
            </a>
          </div>
        </div>

        {/* Column 4: Newsletter Subscription */}
        <div className="footer-col footer-newsletter">
          <h3>Newsletter</h3>
          <p>Subscribe for exclusive discounts & product drops!</p>
          {subscribed ? (
            <div className="newsletter-success">Thank you for subscribing!</div>
          ) : (
            <form onSubmit={handleSubscribe} className="newsletter-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="button newsletter-btn">Subscribe</button>
            </form>
          )}
        </div>
      </div>

      {/* Bottom Copyright bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Star.Ryhwa. All rights reserved. Handmade in Hawaii.</p>
        <div className="footer-bottom-legal">
          <Link to="/terms">Terms</Link>
          <span className="footer-bottom-sep" />
          <Link to="/privacy">Privacy</Link>
          <span className="footer-bottom-sep" />
          <Link to="/shipping-policy">Shipping</Link>
          <span className="footer-bottom-sep" />
          <Link to="/disclaimers">Disclaimers</Link>
          <span className="footer-bottom-sep" />
          <Link to="/accessibility">Accessibility</Link>
        </div>
        <p className="site-maker">
          Site made by{" "}
          <a href="https://github.com/NottKoneko" target="_blank" rel="noopener noreferrer" aria-label="GitHub Profile">
            <FontAwesomeIcon icon={faGithub} />
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
